import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import MobileShell from '@/components/MobileShell';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { formatIncomingOffer, fetchActiveProviderOffers } from '@/lib/providerDispatch';

export default function ProviderOffers() {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const active = await fetchActiveProviderOffers(api);
      setOffers(active);
    } catch {
      toast.error('Could not load offers');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <MobileShell title="Service Offers">
      <div className="px-5 py-5 space-y-3" data-testid="provider-offers-list">
        {loading ? (
          <div className="text-sm text-slate-500">Loading offers…</div>
        ) : offers.length === 0 ? (
          <div className="resqly-card p-6 text-center text-sm text-slate-500">
            No active offers. Stay available to receive nearby requests.
          </div>
        ) : (
          offers.map((offer) => {
            const view = formatIncomingOffer(offer);
            return (
              <Link
                key={offer.id}
                to={`/provider/offers/${offer.id}`}
                className="resqly-card p-4 block hover:shadow-md"
                data-testid={`provider-offer-${offer.id}`}
              >
                <div className="text-xs font-semibold text-blue-700 uppercase">Incoming service request</div>
                <div className="font-semibold text-slate-900 mt-1">{view.serviceName}</div>
                <div className="text-xs text-slate-500 mt-1" data-testid="offer-distance">
                  {view.distanceLabel}
                </div>
                {view.durationDisplay && (
                  <div className="text-xs text-slate-600 mt-1" data-testid="offer-duration">
                    {view.durationDisplay}
                  </div>
                )}
                {view.caseTypeDisplay && (
                  <div className="text-xs text-slate-600" data-testid="offer-case-type">
                    {view.caseTypeDisplay}
                  </div>
                )}
                <div className="text-xs text-blue-700 mt-2 font-medium capitalize">{offer.status}</div>
              </Link>
            );
          })
        )}
        <Button variant="outline" className="w-full" onClick={() => navigate('/provider/dashboard')}>
          Back to dashboard
        </Button>
      </div>
    </MobileShell>
  );
}
